import React, { useState } from 'react';
import { UserPlus, ExternalLink, CheckCircle } from 'lucide-react';
import { contactInfo } from '../data/mock';

const VolunteerSection = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleVolunteerClick = () => {
    // Open the actual Google Form
    window.open(contactInfo.volunteerFormUrl, '_blank');
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  return (
    <section id="volunteer" className="py-20 bg-gradient-to-br from-orange-50 via-yellow-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 p-8 text-center text-white">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-4">
              <UserPlus className="w-10 h-10" />
            </div>
            <h2 className="text-4xl font-bold mb-4">Join Our Mission</h2>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto">
              Become a volunteer and contribute to the revival of Buddhism and social transformation
            </p>
          </div>

          {/* Content */}
          <div className="p-8 space-y-8">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Why Volunteer With Us?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                <div className="p-6 bg-blue-50 rounded-lg border-l-4 border-blue-600">
                  <h4 className="font-bold text-gray-900 mb-2">Make a Difference</h4>
                  <p className="text-gray-700">Contribute to social equality and Buddhist revival</p>
                </div>
                <div className="p-6 bg-yellow-50 rounded-lg border-l-4 border-yellow-600">
                  <h4 className="font-bold text-gray-900 mb-2">Learn & Grow</h4>
                  <p className="text-gray-700">Deepen your understanding of Buddhist philosophy</p>
                </div>
                <div className="p-6 bg-orange-50 rounded-lg border-l-4 border-orange-600">
                  <h4 className="font-bold text-gray-900 mb-2">Community</h4>
                  <p className="text-gray-700">Connect with like-minded individuals</p>
                </div>
                <div className="p-6 bg-red-50 rounded-lg border-l-4 border-red-600">
                  <h4 className="font-bold text-gray-900 mb-2">Impact</h4>
                  <p className="text-gray-700">Create lasting change in society</p>
                </div>
              </div>
            </div>

            {/* Volunteer Areas */}
            <div className="bg-gradient-to-br from-blue-50 to-orange-50 p-6 rounded-xl">
              <h4 className="text-xl font-bold text-gray-900 mb-4 text-center">
                Volunteer Opportunities
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  'Dhamma Education Programs',
                  'Meditation Sessions',
                  'Event Organization',
                  'Community Outreach',
                  'Youth Programs',
                  'Women Empowerment',
                  'Administrative Support',
                  'Social Media & Communications'
                ].map((area, index) => (
                  <div key={index} className="flex items-center gap-3">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                    <span className="text-gray-700">{area}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* CTA Button */}
            <div className="text-center pt-4">
              <button 
                onClick={handleVolunteerClick}
                className="group px-8 py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center gap-3 mx-auto"
              >
                Register as Volunteer
                <ExternalLink className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
              </button>
              <p className="text-sm text-gray-500 mt-3">
                This will open the volunteer registration form
              </p>
            </div>

            {/* Success Message */}
            {showSuccess && (
              <div className="fixed top-24 right-4 bg-green-500 text-white px-6 py-4 rounded-lg shadow-xl flex items-center gap-3 animate-slide-in z-50">
                <CheckCircle className="w-6 h-6" />
                <span className="font-semibold">Registration form opened successfully!</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VolunteerSection;
